import {Directive, HostBinding, Input} from '@angular/core';
import {IsPersianCharsPipe} from '../pipes/is-persian-chars.pipe';

/**
 * switches css class for Persian or English words
 */

@Directive({
  selector: '[langClassSwitcher]',
})
export class LangClassSwitcherDirective {
  private _langClassSwitcher: string;
  private isPersian = false;

  @Input() get langClassSwitcher(): string {
    return this._langClassSwitcher;
  };

  @HostBinding('class.en-text') get isEnText() {
    return !this.isPersian;
  }

  @HostBinding('class.fa-text') get isFaText() {
    return this.isPersian;
  }

  set langClassSwitcher(value: any) {
    this._langClassSwitcher = value;
    this.isPersian = IsPersianCharsPipe.isPersian(this.langClassSwitcher);
  };

}
